import styled from 'styled-components'
import { CompactButton } from 'components/sto/Section'
import { stoColor, stoRadius, stoShadow, stoSpace, stoType } from 'constants/stoTheme'

/** Figma "Button Outlined" when chosen, "Button Text" otherwise. */
export const MenuButton = styled(CompactButton)<{ $active: boolean }>`
  && {
    background: transparent;
    border-color: ${({ $active }) => ($active ? stoColor.borderSubtle : 'transparent')};
    color: ${({ $active }) => ($active ? stoColor.textPrimary : stoColor.textSecondary)} !important;
  }

  &&:hover,
  &&:focus-visible {
    background: transparent;
    border-color: ${({ $active }) => ($active ? stoColor.textPrimary : 'transparent')};
    color: ${stoColor.textPrimary} !important;
  }
`

/** Fixed in <body>, placed by OptionMenu; above the page and the mobile Key Actions sheet. */
export const Menu = styled.ul`
  position: fixed;
  z-index: 1010;
  min-width: 140px;
  margin: 0;
  padding: ${stoSpace[1]} 0;
  overflow-y: auto;
  list-style: none;
  background: ${stoColor.surface};
  border: 1px solid ${stoColor.borderSubtle};
  border-radius: ${stoRadius.sm};
  box-shadow: ${stoShadow.sm};
`

export const MenuItem = styled.button<{ $selected: boolean }>`
  ${stoType.bodySmTight};
  display: block;
  width: 100%;
  padding: ${stoSpace[2]} ${stoSpace[4]};
  border: none;
  background: ${({ $selected }) => ($selected ? stoColor.surfaceAlt : 'transparent')};
  font-weight: 600;
  text-align: left;
  color: ${({ $selected }) => ($selected ? stoColor.textPrimary : stoColor.textSecondary)};
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background: ${stoColor.surfaceAlt};
    color: ${stoColor.textPrimary};
    outline: none;
  }
`
